import { render, staticRenderFns } from "./Headers.vue?vue&type=template&id=3d9630f3&scoped=true"
import script from "./Headers.vue?vue&type=script&lang=ts"
export * from "./Headers.vue?vue&type=script&lang=ts"
import style0 from "./Headers.vue?vue&type=style&index=0&id=3d9630f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d9630f3",
  null
  
)

export default component.exports